"use client";

import { CSSProperties, useState } from "react";
import imageSample from "@/shared/images/image-sample.webp";
import Image from "next/image";
import "./ComparisonSlider.css";
import { IElement, IStaticText } from "./interfaces";

export const ComparisonSlider = ({
  element,
  staticText,
}: {
  element: IElement;
  staticText: IStaticText;
}) => {
  const [sliderValue, setSliderValue] = useState(50);

  const firstImage =
    element && element.imageAfter
      ? `https://api.blwall.com${element.imageBefore.data.attributes.url}`
      : imageSample;

  const secondImage =
    element && element.imageAfter
      ? `https://api.blwall.com${element.imageAfter.data.attributes.url}`
      : imageSample;

  const handleChange = (e: any) => {
    if (e.type === "change") {
      const value = parseInt(e.currentTarget.value);
      setSliderValue(value);
    } else {
      const touchPosition = e.touches[0].clientX;
      const sliderWidth = e.target.clientWidth;
      const newValue = (touchPosition / sliderWidth) * 100;
      setSliderValue(newValue);
    }
  };

  const switchImages = () => {
    let id = 0;
    let value: number;

    const frameForward = () => {
      if (value === 100) {
        clearInterval(id);
      } else {
        value++;
        setSliderValue(value);
      }
    };

    const frameBackward = () => {
      if (value === 0) {
        clearInterval(id);
      } else {
        value--;
        setSliderValue(value);
      }
    };

    if (sliderValue > 50) {
      value = sliderValue;
      clearInterval(id);
      setInterval(frameBackward, 10);
    } else {
      value = sliderValue;
      clearInterval(id);
      setInterval(frameForward, 10);
    }
  };

  return (
    <section className={"comparison"}>
      <div className={"comparison__sliderContainer"}>
        <Image
          className={"comparison__image"}
          src={firstImage}
          alt="before"
          fill={true}
          loading="lazy"
        />
        <Image
          className={"comparison__image_finaly"}
          src={secondImage}
          alt="after"
          fill={true}
          loading="lazy"
          style={
            {
              "--exposure": `${sliderValue}%`,
            } as CSSProperties
          }
        />
        <input
          type="range"
          min="1"
          max="100"
          value={sliderValue}
          className={"comparison__slider"}
          name="slider"
          id="slider"
          onChange={handleChange}
          onTouchStart={handleChange}
          onTouchMove={handleChange}
          onTouchEnd={handleChange}
        />
        <div
          className={"sliderButton"}
          style={{
            left: `calc(${sliderValue}%`,
          }}
        ></div>
      </div>
      <div
        className={`comparison__description ${
          sliderValue <= 50 ? "before_active" : "after_active"
        }`}
      >
        <span className={"comparison__text_first"} onClick={switchImages}>
          {!!element.textBefore
            ? element.textBefore
            : staticText.comparisonSliderTextBefore || ""}
        </span>
        <input
          type="range"
          className={"comparison__miniSlider"}
          min="1"
          max="100"
          value={sliderValue}
          onChange={handleChange}
          onTouchStart={handleChange}
        />
        <span className={"comparison__text_second"} onClick={switchImages}>
          {!!element.textAfter
            ? element.textAfter
            : staticText.comparisonSliderTextAfter || ""}
        </span>
      </div>
    </section>
  );
};
